import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '@core/services/storage.service';
import { UsersService } from '@services/users.service';

@Injectable({ providedIn: 'root' })
export class CheckLoginGuard implements CanActivate {
  constructor(private usersService: UsersService, private router: Router, private storageService: StorageService) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    const user = this.usersService.userValue;
    const sessionKey = (this.storageService.get('SessionKey') || '');
    if (user && sessionKey && !state.url.includes('login')) { // !! UYARI !! : "!state.url.includes('login')" ANGULAR PROJESİNE GEÇİŞ SAĞLANDIKTAN SONRA BU KONTROL KALDIRILACAKTIR.
      this.router.navigate(['/dashboard']);
      return false;
    }

    // not logged in so redirect to login page with the return url
    return true;
  }
}
